import React, {PureComponent} from 'react';
import {getImageDomain} from 'app/utils';

export interface ImageProps {
    image: {
        url: string,
        name?: string
    },
    className?: string;
    alt?: string;
    title?: string;
    imageDomain?: boolean
}

export default class Image<T extends ImageProps> extends PureComponent<T> {
    render(): React.ReactNode {
        const {image: {url, name}, className, alt, title, imageDomain} = this.props;
        const prefix = imageDomain ? getImageDomain(false) : '';
        const img_url = `${prefix}${url}`;

        return <img
            src={img_url}
            className={className}
            alt={alt || name}
            title={title || name}
        />;
    }
}
